import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template17.css";
import "./CheckoutTemplate17.css";

/*
   Checkout Template 17 — a seamless continuation of sales Template 17
   ("Neon Terminal"). Reuses Template17.css directly (same .clp17-root design
   system): the real .tm17-nav, the dark terminal .tm17-hero band with its
   grid-bg + glow and .tm17-title, the .tm17-btn .tm17-btn-p button and the
   .tm17-foot footer. Only the form + order summary cards are checkout-specific
   (CheckoutTemplate17.css), styled as dark obsidian panels to match the
   template's .tm17-window / .tm17-card look.
*/
export default function ThankYouTemplate17({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp17-root">
      {/* Technical grid + glow backdrop — same as the sales page */}
      <div className="tm17-grid-bg" aria-hidden="true" />
      <div className="tm17-glow" aria-hidden="true">
        <span className="b b1" />
        <span className="b b2" />
      </div>

      {/* NAV — same as the sales page */}
      <nav className="tm17-nav scr">
        <div className="tm17-wrap tm17-nav-in">
          <span className="tm17-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok17-brandtext">{c.brand}</span>}
          </span>
          <span className="cok17-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales terminal hero band + accent-word title */}
      <header className="tm17-hero cok17-hero">
        <div className="tm17-wrap">
          <div className="cok17-hero-in">
            <span className="cok17-eyebrow">Thank you</span>
            <h1 className="tm17-title">
              You're <span className="cok17-accent">enrolled</span>
            </h1>
            {c.sub ? <p className="tm17-sub cok17-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's dark card style */}
      <div className="tm17-wrap">
        <ThankYouBody data={data} p="cok17" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="tm17-foot">
        <div className="tm17-wrap tm17-foot-in">
          <div className="cok17-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
